import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {StatCard} from './stat-card';
import {UsageProgress} from './usage-progress';

interface Props {
    currentMonthUsage: number;
    currentMonthLimit: number | null;
    lastMonthUsage: number;
}

export function UsageStats(props: Props) {
    const limitDisplay =
        props.currentMonthLimit !== null ? props.currentMonthLimit.toLocaleString() : '∞';

    const clampedUsage =
        props.currentMonthLimit !== null
            ? Math.min(props.currentMonthUsage, props.currentMonthLimit)
            : props.currentMonthUsage;

    return (
        <Stack isHorizontal={true} spacing={16} isFullWidth={true}>
            <div className='flex-grow'>
                <StatCard label='This month’s usage'>
                    <Body color='dark' size='xlarge' isBold={true}>
                        {clampedUsage.toLocaleString()} / {limitDisplay}
                    </Body>
                    {props.currentMonthLimit !== null && (
                        <UsageProgress used={clampedUsage} limit={props.currentMonthLimit} />
                    )}
                </StatCard>
            </div>
            <div className='flex-grow'>
                <StatCard label='Last month’s usage'>
                    <Body color='dark' size='xlarge' isBold={true}>
                        {props.lastMonthUsage.toLocaleString()}
                    </Body>
                </StatCard>
            </div>
        </Stack>
    );
}
